import styled from "@emotion/styled";
import { Flex, Type } from "mesh-component-library";

export const Container = styled.div`
  width: 100%;
  padding: 0 14px;
`;

export const FullWidthFlex = styled(Flex)`
  width: 100%;
`;

export const HiddenDiv = styled.div`
  display: hidden;
`

export const CommunityText = styled(Type)`
  color: #CDCDCD;
`